import { FC } from "react";

import { Pill } from "@/components/Interface/Pill/Pill";

type ChipTone = "default" | "info" | "inverted";

const toneClassMapping: Record<ChipTone, string> = {
  default: "bg-surface-quaternary text-foreground-primary",
  info: "bg-surface-quaternary text-foreground-info",
  inverted: "bg-surface-tertiary-inverse text-foreground-primary-inverse",
};

interface Props {
  text: string | number;
  tone?: ChipTone;
}

/** The design system's small dire-chip: 24 px tall, tinted, semibold label. */
export const BillingAccountChip: FC<Props> = ({ text, tone = "default" }) => (
  <Pill className={toneClassMapping[tone]} size="sm" text={text} />
);
